export const Button = ({ onClick, text, className }) => {
  return (
    <button className={`btn btn-primary text-end text-white ${className}`} onClick={onClick}>
      {text}
    </button>
  );
};
